import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  result: undefined,
  error: undefined,
};

const change = (store, data) => {
  store.setState((state) => {
    state.developer.stamping.comprobante.data = {
      ...state.developer.stamping.comprobante.data,
      ...data,
    };
  });
};

const info = async (store, id) => {
  store.setState((state) => {
    state.developer.stamping.comprobante.busy = true;
  });

  try {
    const data = { ...store.state.developer.stamping.comprobante.data };

    const response = await Http.get(`/app/audits/timbrado/comprobantes/${id}`, data);

    store.setState((state) => {
      state.developer.stamping.comprobante.busy = false;
      state.developer.stamping.comprobante.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.developer.stamping.comprobante.busy = false;
      state.developer.stamping.comprobante.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.developer.stamping.comprobante = { ...initialState };
  });
};

const TimbradoComprobanteInfoStore = {
  state: () => initialState,
  actions: {
    change,
    info,
    reset,
  },
};

export default TimbradoComprobanteInfoStore;
